import { render, staticRenderFns } from "./LeadsUnderManagementIcon.vue?vue&type=template&id=a3bdf53a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports